
import { defineComponent } from "vue";
import messages from "@/config/messages";
import { mapGetters, mapMutations } from "vuex";
import * as apiClient from "@/apiclient/";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    electionDependentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      validationMsg: "",
      isFormInvalid: false,
    };
  },
  computed: {
    ...mapGetters(["getFormDirty", "getEnrollment"]),
  },
  methods: {
    closeModal(): void {
      this.$emit("close");
    },
    async deleteDependent(): Promise<void> {
      this.validationMsg = "";
      this.isFormInvalid = false;
      const params = {
        electionDependentId: this.electionDependentId,
        customerParticipantId: this.getEnrollment.customerParticipantId,
      };
      const result = await await apiClient
        .dependentController()
        .deleteApiDependent(params);
      if (!result || result.error) {
        this.isFormInvalid = true;
        if (result.error) {
          this.validationMsg = result.error + messages.errorMsg;
        }
      } else if (result.data) {
        this.closeModal();
        this.$emit("getDependents");
      }
    },
  },
});
